
































import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user';
import IconOrLoader from '@/components/svg/IconOrLoader.vue';

@Component({
    components: {
        IconOrLoader,
    },
})
export default class ForgotPassword extends Vue {
    email: string = null;

    userService = new UserService();

    showConfirmation = false;

    loading = false;

    requestPasswordReset() {
        this.loading = true;
        this.userService
            .requestPasswordReset(this.email)
            .then(() => {
                this.showConfirmation = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
